import { useEffect, useRef } from 'react';
import { isBrowser } from 'ws-scripts/modules/environment';
import logger from 'ws-scripts/modules/logger';

const LOG_PREFIX = '[ws-locations-control][useLocationsFilter]';

/**
 * Hook to reset the LocationsData make filter whenever the input string
 * transitions from non-empty to empty. This covers both the clear button
 * click and the user manually deleting the input with the backspace key.
 *
 * @param {string} inputString - The current autocomplete input value.
 */
export const useLocationsFilter = (inputString) => {
	const prevInputRef = useRef(inputString);

	useEffect(() => {
		const wasNonEmpty = prevInputRef.current.trim() !== '';
		prevInputRef.current = inputString;

		// Only act when the input transitions from non-empty → empty
		if (!wasNonEmpty || inputString.trim() !== '') {
			return;
		}

		if (!isBrowser) {
			return;
		}

		const locationsData = window.DDC?.LocationsData;

		if (!locationsData?.resetMakeFilter) {
			logger.warn(
				`${LOG_PREFIX} LocationsData.resetMakeFilter not available`
			);
			return;
		}

		if (locationsData.hasActiveFilters?.()) {
			locationsData.resetMakeFilter();
			logger.debug(
				`${LOG_PREFIX} Called LocationsData.resetMakeFilter()`
			);
		} else {
			logger.debug(
				`${LOG_PREFIX} Skipping resetMakeFilter — no active make filter`
			);
		}
	}, [inputString]);
};
